import { api } from '../api';

// Поток событий заказов (SSE) с пропуском сотрудника. Интерфейс как у EventSource
// (onmessage / onerror / onopen / close) — страницы меняют одну строку.
// EventSource не умеет заголовки, поэтому короткий токен потока (60 мин) идёт в адресе;
// при обрыве (в т.ч. сервер закрыл поток или не пустил по токену) — новый токен и
// переподключение с паузой 2 → 4 → 8 → 16 → 30 с.

const API_BASE = process.env.REACT_APP_API_URL || '/api';

// Пропуск один на живые каналы сотрудника: поток заказов и остатки каталога.
export function openOrdersStream() {
  return openStaffStream('/orders/stream');
}

export function openStaffStream(path) {
  let es = null;
  let closed = false;
  let retry = 0;
  let timer = null;

  const stream = {
    onmessage: null,
    onerror: null,
    onopen: null,
    close() {
      closed = true;
      clearTimeout(timer);
      if (es) es.close();
    },
  };

  const schedule = (ms) => { if (!closed) timer = setTimeout(connect, ms); };

  async function connect() {
    if (closed) return;
    try {
      const { token } = await api.getOrdersStreamToken();
      if (closed) return;
      es = new EventSource(`${API_BASE}${path}?token=${encodeURIComponent(token)}`);
      es.onopen = (e) => { retry = 0; if (stream.onopen) stream.onopen(e); };
      es.onmessage = (e) => { if (stream.onmessage) stream.onmessage(e); };
      es.onerror = (e) => {
        es.close();
        if (stream.onerror) stream.onerror(e);
        schedule(Math.min(30000, 2000 * 2 ** Math.min(retry++, 4)));
      };
    } catch (e) {
      schedule(5000);
    }
  }

  connect();
  return stream;
}
